jQuery(function ($) {

  function findOptionLabelContains(text) {
    return $('.oz__option-label').filter(function () {
      return $(this).text().trim().toLowerCase().includes(text.toLowerCase());
    }).closest('.oz__option-type-dropdown');
  }

  const broan = findOptionLabelContains('Broan Vent Insert');
  const tradewinds = findOptionLabelContains('Tradewinds Vent Insert');

  // Proper Optionize reset
  function resetOption(select) {

    if (!select.length) return;

    select.val('');

    select[0].dispatchEvent(
      new Event('change', { bubbles: true })
    );

    select[0].dispatchEvent(
      new Event('input', { bubbles: true })
    );
  }

  // Enable first disabled options
  $('.oz__option-type-dropdown select').each(function () {
    $(this).find('option:disabled').prop('disabled', false);
  });

  const allowedBroanSizes = ["30", "36"];
  const allowedTradewindsSizes = ["30", "36", "42", "48", "54", "60"];

  function filterVentOptions(selectedSizes) {

    const sizes = selectedSizes.map(txt => {
      const match = txt.match(/^(\d+)\s*W/);
      return match ? match[1] : null;
    }).filter(Boolean);

    // Reset both vent selections first

    broan.show();
    tradewinds.show();

    // Broan visibility
    if (sizes.some(s => allowedBroanSizes.includes(s))) {
      broan.show();
    } else {
      broan.hide();
      resetOption(broan.find('select'));
    }

    // Tradewinds visibility
    if (sizes.some(s => allowedTradewindsSizes.includes(s))) {
      tradewinds.show();
    } else {
      tradewinds.hide();
      resetOption(tradewinds.find('select'));
    }

    // Filter Broan options
    broan.find('option').each(function () {

      const text = $(this).text();
      const match = text.match(/^(\d+)/);
      const optionSize = match ? match[1] : null;

      if (!optionSize || sizes.includes(optionSize)) {
        $(this).show();
      } else {
        $(this).hide();
      }

    });

    // Filter Tradewinds options
    tradewinds.find('option').each(function () {

      const text = $(this).text();
      const match = text.match(/^(\d+)/);
      const optionSize = match ? match[1] : null;

      if (!optionSize || sizes.includes(optionSize)) {
        $(this).show();
      } else {
        $(this).hide();
      }

    });

  }

  function bindSizeDropdown() {

    const sizeDropdown = $('.oz__option-label').filter(function () {
      return $(this).text().trim().toLowerCase().includes('size');
    }).closest('.oz__option-type-dropdown').find('select');

    sizeDropdown.off('change.vent');

    sizeDropdown.on('change.vent', function () {

    const selectedText = $(this).find('option:selected').text().trim();

    if (!selectedText) return;

    // Always grab CURRENT dropdowns
    const currentBroan = $('select[name="Broan Vent Insert"]');
    const currentTradewinds = $('select[name="Tradewinds Vent Insert"]');

    resetOption(currentBroan);
    resetOption(currentTradewinds);

    setTimeout(function () {

    filterVentOptions([selectedText]);

    setTimeout(function(){

        const broanSelect = $('select[name="Broan Vent Insert"]');

        broanSelect.prop('selectedIndex', 0);

        broanSelect[0].dispatchEvent(
          new Event('change', { bubbles: true })
        );

        broanSelect[0].dispatchEvent(
          new Event('input', { bubbles: true })
        );

    }, 100);

}, 300);

});

    // Initial load
    const defaultSizeText = sizeDropdown.find('option:selected').text().trim();

    if (defaultSizeText) {
      filterVentOptions([defaultSizeText]);
    }

  }

  // Only one vent at a time

  broan.find('select').on('change', function () {

    if ($(this).val()) {

      tradewinds.hide();

      resetOption(
        tradewinds.find('select')
      );

    } else {

      tradewinds.show();

    }

  });

  tradewinds.find('select').on('change', function () {

    if ($(this).val()) {

      broan.hide();

      resetOption(
        broan.find('select')
      );

    } else {

      broan.show();

    }

  });

  // Watch Color changes (Optionize AJAX reload)

  const colorDropdown = $('.oz__option-label').filter(function () {
    return $(this).text().trim().toLowerCase().includes('color');
  }).closest('.oz__option-type-dropdown').find('select');

  colorDropdown.on('change.colorwatch', function () {

    const interval = setInterval(function () {

      const newSizeDropdown = $('.oz__option-label').filter(function () {
        return $(this).text().trim().toLowerCase().includes('size');
      }).closest('.oz__option-type-dropdown').find('select');

      if (
        newSizeDropdown.length &&
        newSizeDropdown.find('option').length > 1
      ) {

        clearInterval(interval);

        bindSizeDropdown();

      }

    }, 400);

  });

  bindSizeDropdown();

});